import { useState } from "react";
import { BusinessModel, Split, SwapAccount } from "../models/Split";
import { api, api_banking } from "../services/Api";
import { showToast } from "../utils";

export function useSplit() {
  const baseUrl = "/sellers";

  const [sellerSplitData, setSellerSplitData] = useState<Split>(null);
  const [sellerSwapData, setSellerSwapData] = useState<SwapAccount[]>([]);
  const [sellerBusinessModelData, setBusinessModelData] = useState<BusinessModel>(null);
  const [splitModalState, setSplitModalState] = useState<boolean>(false);
  const [splitSwitchState, setSplitSwitchState] = useState<boolean>(false);
  const [closeSwapModalState, setCloseSwapModalState] = useState<boolean>(false);

  const activeSellerSplit = (id: string) => {
    return api.post(`${baseUrl}/${id}/split`);
  }

  const editSellerSplitConfig = (id: string, requestBody: Split) => {
    return api.patch(`${baseUrl}/${id}/split`, requestBody);
  }

  const getSplitData = (id: string) => {
    return api.get(`${baseUrl}/${id}/split`);
  }

  const getBusinessModel = (id: string) => {
    return api.get(`${baseUrl}/${id}/business-model`);
  }

  const editBusinessModelConfig = (id: string, requestBody: BusinessModel) => {
    return api.patch(`${baseUrl}/${id}/business-model`, requestBody);
  }

  const getSwapAccount = (sellerId: string) => {
    return api_banking.get(`accounts/${sellerId}`);
  }


  const closeSwapAccount = (sellerId: string, file: any) => {
    let formData = new FormData();
    formData.append("file", file);
    return api_banking.put(`accounts/${sellerId}/close`, formData)
  }

  const generateSwapPixCredit = (sellerId: string, accountId: string) => {
    return api_banking.post(`accounts/${sellerId}/credit-key`, 
      {
        accountId,
        keyType: "EVP"
      }
    )
  }


  async function handleActiveSellerSplit(id: string) {
    try {
      await activeSellerSplit(id);
      showToast({
        type: "success",
        message: `Sucesso`
      });
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha ao ativar o Split do seller."
      });
    }
  }

  async function getSliptInitialData(id: string) {
    try {
      const { data } = await getSplitData(id);
      setSellerSplitData(data);
      setSplitSwitchState(data.transferPolicyEnabled);
    } catch (error) {
      // error?.response?.data?.errors?.map((error:any) => (
      //   showToast({
      //     type: "error",
      //     message: `${error?.code} - ${error?.description}`
      //   })
      // ));
    }
  }

  async function getSwapInitialData(id: string) {
    try {
      const { data } = await getSwapAccount(id);
      setSellerSwapData(data);
      setSplitSwitchState(data.transferPolicyEnabled);
    } catch (error) {
      // error?.response?.data?.errors?.map((error:any) => (
      //   showToast({
      //     type: "error",
      //     message: `${error?.code} - ${error?.description}`
      //   })
      // ));
    }
  }

  async function getBusinessModelData(id: string) {
    try {
      const { data } = await getBusinessModel(id);
      setBusinessModelData(data);
    } catch (error) {
      // error?.response?.data?.errors?.map((error:any) => (
      //   showToast({
      //     type: "error",
      //     message: `${error?.code} - ${error?.description}`
      //   })
      // ));
    }
  }

  return {
    activeSellerSplit,
    editSellerSplitConfig,
    getSplitData,
    getBusinessModel,
    editBusinessModelConfig,
    handleActiveSellerSplit,
    getSliptInitialData,
    getSwapInitialData,
    getBusinessModelData,
    setSplitModalState,
    setSplitSwitchState,
    setCloseSwapModalState,
    closeSwapAccount,
    generateSwapPixCredit,
    sellerSplitData,
    sellerSwapData,
    sellerBusinessModelData,
    splitModalState,
    closeSwapModalState,
    splitSwitchState
  };
}
